// extracted by mini-css-extract-plugin
module.exports = {"container":"_8cff1e1","details":"_8551f49","inPlay":"_5882f48","slide":"_4f57cc0","slideDown":"_f0f55f6"};